import { ErrorIcon, SuccessIcon } from "./Icons";
import { Message } from "wvus-forms";
import { CreditCardTypes } from "./CreditCardTypes";
import CreditCardTokenExField from "./CreditCardTokenExField";
import Shimmer from "./Shimmer";
import { getPhrase, Say } from "../../languages";

export function CreditCardField(props) {
  const {
    tokenExConfigQuery,
    refIframe,
    secondInteraction,
    validationErrorCCPhraseKey,
    handleIframeError,
    handleIframeLoadError,
    handleIframeInitTimeout,
    handleIframeLoadDeadline,
    handleIframeLoaded,
    initTimeout,
    loadDeadline,
    fieldAlertMessagePhraseKey,
    onCardTypeChange = () => {},
    onTokenize = () => {},
    onValidate = () => {},
    onExpire = () => {},
    onBlur = () => {},
    onFocus = () => {},
    isCCValid,
    cardType,
    disabled,
    setTokenExError
  } = props;
  const iframeConfig = tokenExConfigQuery?.data || {};

  const isLoading = !iframeConfig?.authenticationKey && !tokenExConfigQuery?.exhausted;

  return (
    <>
      <Shimmer
        className="payment-field-shimmer"
        isLoading={isLoading || disabled}
        height="43px"
        width="100%">
        <CreditCardTokenExField
          iframeConfig={iframeConfig}
          fieldId="wvus_new_cc_number"
          refIframe={refIframe}
          onCardTypeChange={onCardTypeChange}
          setTokenExError={setTokenExError}
          handleIframeError={handleIframeError}
          handleIframeLoadError={handleIframeLoadError}
          initTimeout={initTimeout}
          loadDeadline={loadDeadline}
          onLoad={() => {
            handleIframeLoaded?.();
          }}
          onLoadDeadline={() => {
            handleIframeLoadDeadline?.();
          }}
          onTokenize={onTokenize}
          onExpire={onExpire}
          onValidate={onValidate}
          onBlur={onBlur}
          onFocus={onFocus}
          onInitTimeout={() => {
            // The iframe has not reported 'load' within its init window. Report it so the
            // rate is measurable, but take no UI action since iframe frequently loads a
            // bit later on a slow connection.
            // A hard failure still arrives with handleIframeError
            handleIframeInitTimeout?.();
          }}
          isValid={isCCValid}
          secondInteraction={secondInteraction}
          fieldAlertMessagePhraseKey={fieldAlertMessagePhraseKey}
          renderMessage={() => {
            if (!isCCValid && secondInteraction) {
              return (
                <Say phrase="errors.valid_credit_card">
                  <Message
                    showError={true}
                    showSuccess={false}
                    message={getPhrase(validationErrorCCPhraseKey)}
                    errorIcon={<ErrorIcon />}
                  />
                </Say>
              );
            } else if (isCCValid) {
              return (
                <Message
                  showError={false}
                  showSuccess={true}
                  message=""
                  successIcon={<SuccessIcon />}
                />
              );
            }

            return null;
          }}
        />
      </Shimmer>
      <CreditCardTypes activeType={cardType} />
    </>
  );
}

export default CreditCardField;
